<template>
  <div class="intro" v-if="userData">
    <div class="hero" v-bind:class="{'has-avatar': avatar}">
      <div class="hero__images" v-if="scoreData">
        <span class="hero__avatar" v-if="avatar"><img :src="avatar"></span>
        <span class="hero__bird" v-if="scoreData.image"><img :src="scoreData.image"></span>
      </div>
    </div>
    <div class="content" v-if="scoreData">
      <span class="subtitle">{{ stationData.auswertung_title }}</span>
      <h2>{{ scoreData.title.rendered }}</h2>
      <p>{{ scoreData.text }}</p>
    </div>
    <div class="buttons" v-if="showButton">
      <a v-bind:class="{ inactive: loading }" class="btn-start btn" href="#" @click.prevent="proceed">{{ $t('evaluation.next') }}</a>
    </div>
  </div>
</template>

<script>
import {Howl, Howler} from 'howler';
import axios from 'axios';

export default {
  name: 'Evaluation',
  props: ['userData', 'stationData'],
  mounted() {
    this.loadData();
  },
  data: () => {
    return {
      loading: false,
      scoreData: null,
      showButton: false
    }
  },
  methods: {
    loadData() {
      let url = window.apiUrl + '/api/visitors/' + this.userData.id + '/score?lang=' + this.$i18n.locale;

      axios.get(url)
      .then((data) => {
        this.scoreData = data.data;
        this.playAudio();
      })
      .catch((error) => {
        console.log(error);
      });
    },
    playAudio() {
      if(!this.scoreData.voiceover) return;
      
      this.voiceover = new Howl({
        src: [this.scoreData.voiceover],
        autoplay: true
      });
      this.voiceover.on('end', () => {
        this.showButton = true;
      });
    },
    proceed() {
      this.$emit('navigate', 'AudioIntro');
    },
  },
  computed: {
    birdPic: function() {
      return 'https://picsum.photos/600/600';
    },
    avatar: function() {
      if(!this.userData.avatar_url) return null;
      return this.userData.avatar_url;
    }
  }
}
</script>

<style scoped lang="scss">

.intro {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;  
}
.hero {
  background-color: var(--white);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  z-index: 1;
  text-align: left;

  &__images {
    width: 20rem;
    height: 20rem;
    position: absolute;
    left: 50%;
    margin-left: -10rem;
    bottom: -10rem;

    .has-avatar & {
      margin-left: -5rem;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  &__bird {
    display: block;
    width: 20rem;
    height: 20rem;
    border-radius: 99%;
    overflow: hidden;
    position: relative;
    opacity: 0;
    animation: bounce-in .3s cubic-bezier(0.175, 0.885, 0.320, 1.275) .5s 1 forwards;

    img {
      object-fit: cover;
    }
  }
  &__avatar {
    position: absolute;
    width: 12rem;
    height: 12rem;
    border-radius: 99%;
    overflow: hidden;
    z-index: 1;
    top: 50%;
    margin-top: -6rem;
    left: -10rem;
    opacity: 0;
    animation: bounce-in .3s cubic-bezier(0.175, 0.885, 0.320, 1.275) 1s 1 forwards;
  }
}
.content {
  padding: 4rem;
  padding-top: calc(20vh + 14rem);
  font-family: 'Syntax';
  font-size: 1rem;
  text-align: center;
}
.subtitle {
  opacity: 1;
}
h2 {
  font-size: 3.5rem;
  font-family: 'GT Sectra', serif;
  margin: 0;
  margin-top: 1.5rem;
}
p {
  font-size: 1.25rem;
  max-width: 30rem;
  margin: 1rem auto;
}
.buttons {
  position: absolute;
  bottom: 4rem;
  left: 6rem;
  width: calc(100% - 12rem);
  margin: 0;
}

@keyframes bounce-in {
  from {
    transform: scale(.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

</style>
